{
  "Zendesk": {
    "category": "STRICTLY_NECESSARY"
  },
  "Google reCaptcha": {
    "category": "STRICTLY_NECESSARY"
  },
  "AWS": {
    "category": "STRICTLY_NECESSARY"
  },
  "Paypal": {
    "category": "STRICTLY_NECESSARY"
  },
  "Datadog": {
    "category": "ANALYTICS"
  },
  "Google Analytics": {
    "category": "ANALYTICS"
  },
  "Google Adsense": {
    "category": "MARKETING"
  },
  "Snowplow": {
    "category": "ANALYTICS"
  },
  "Hotjar": {
    "category": "ANALYTICS"
  },
  "Optimizely": {
    "category": "ANALYTICS"
  },
  "TikTok": {
    "category": "MARKETING"
  },
  "Facebook": {
    "category": "MARKETING"
  },
  "TVSquared": {
    "category": "MARKETING"
  },
  "Bing": {
    "category": "MARKETING"
  },
  "Reddit": {
    "category": "MARKETING"
  },
  "Google Doubleclick": {
    "category": "MARKETING"
  },
  "Google": {
    "category": "STRICTLY_NECESSARY"
  },
  "Yahoo": {
    "category": "MARKETING"
  },
  "Pinterest": {
    "category": "MARKETING"
  },
  "Glassdoor": {
    "category": "MARKETING"
  },
  "Sumo": {
    "category": "MARKETING"
  }
}